// Paithani-inspired SVG patterns for decorative borders and accents
// Patterns are subtle and used at low opacity (15-25%)

export const patterns = {
  // Traditional peacock feather motif pattern
  peacockFeather: `
    <pattern id="peacock-feather" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
      <path
        d="M20 5 Q 15 15 20 25 Q 25 15 20 5 M 20 25 L 20 35"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        opacity="0.3"
      />
      <circle cx="20" cy="5" r="2" fill="currentColor" opacity="0.4"/>
    </pattern>
  `,

  // Geometric diamond/kaleidoscope pattern
  diamond: `
    <pattern id="diamond" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
      <path
        d="M15 0 L30 15 L15 30 L0 15 Z"
        stroke="currentColor"
        fill="none"
        strokeWidth="1"
        opacity="0.2"
      />
    </pattern>
  `,

  // Paisley-inspired curved motif
  paisley: `
    <pattern id="paisley" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
      <path
        d="M25 10 Q 35 15 35 25 Q 35 35 25 40 Q 20 38 20 30 Q 20 20 25 10"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        opacity="0.25"
      />
    </pattern>
  `,

  // Simple dot grid pattern
  dots: `
    <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
      <circle cx="10" cy="10" r="1.5" fill="currentColor" opacity="0.2"/>
    </pattern>
  `,

  // Wave/border pattern
  wave: `
    <pattern id="wave" x="0" y="0" width="60" height="20" patternUnits="userSpaceOnUse">
      <path
        d="M0 10 Q 15 5 30 10 T 60 10"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        opacity="0.25"
      />
    </pattern>
  `
};

export const patternNames = Object.keys(patterns) as Array<keyof typeof patterns>;
